import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "./store";
const options = {
  latencyThreshold: 200,
  router: true,
  http: false
};
Vue.use(NProgress, options);
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /*
    | Routers for Index
    */
    {
      path: "*",
      name: "error404",
      component: () =>
        import(
          /* webpackChunkName: "dukahome" */ "./index/components/Error404.vue"
        )
    },
    {
      path: "/",
      name: "signup",
      component: () =>
        import(
          /* webpackChunkName: "dukaadministrator" */ "./index/components/SignUp.vue"
        ),
      meta: {
        title: "Sign up to invoice management"
      }
    },
    {
      path: "/verify-email/:code",
      name: "linkverification",
      component: () =>
        import(
          /* webpackChunkName: "dukahome" */ "./index/components/LinkVerification.vue"
        )
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(
          /* webpackChunkName: "dukaadministrator" */ "./index/components/Login.vue"
        ),
      meta: {
        title: "Log into your account"
      }
    },
    {
      path: "/reset-account-password",
      name: "resetpassword",
      component: () =>
        import(
          /* webpackChunkName: "dukaadministrator" */ "./index/components/ResetPassword.vue"
        ),
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: "/account",
      name: "customeraccount",
      component: () =>
        import(
          /* webpackChunkName: "customerAccount" */ "./account/components/CustomerAccount.vue"
        ),
      meta: {
        requiresUserAuth: true
      }
    },
    {
      path: "/account/create-invoice",
      name: "invoicecreation",
      component: () =>
        import(
          /* webpackChunkName: "customerAccount" */ "./account/components/ScratchInvoice.vue"
        ),
      meta: {
        requiresUserAuth: true
      }
    },
    {
      path: "/account/account-setup",
      name: "accountsetup",
      component: () =>
        import(
          /* webpackChunkName: "customerAccount" */ "./account/components/Profile.vue"
        ),
      meta: {
        requiresUserAuth: true
      }
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.matched.some(record => record.meta.requiresUserAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    window.location.replace("/login");
  } else if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    window.location.replace("/admin");
  } else if (to.matched.some(record => record.meta.requiresCustomerAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    window.location.replace("/customer");
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
